import { render, staticRenderFns } from "./InseratUeberblick.vue?vue&type=template&id=2f7e9a24&scoped=true"
import script from "./InseratUeberblick.vue?vue&type=script&lang=js"
export * from "./InseratUeberblick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e9a24",
  null
  
)

export default component.exports